import { TemplateElement } from '@bynder-studio/render-core';
import { ColorParams, ExtendedColorParams, Gradient, SolidColor, UnifiedCommonColor } from '@bynder-studio/misc';
import { toRGBA } from 'packages/pages/editor/RightSideMenu/Shots/Text/TextStyles/utils';
import {
    hexToRgb,
    isGradientColor,
    rgbToHex,
} from 'packages/pages/editor/RightSideMenu/FormComponents/ColorPicker/utils';
import { brandColor2ColorParams, colorToCSS, rgbaToObject } from '~/common/editor/editorHelper';
import { BrandColor } from 'packages/store/brandColors/types';

export const getUnifiedColor = (
    color: ColorParams,
    byId: { [brandColorId: number]: BrandColor },
): UnifiedCommonColor => {
    const extraParams = isGradientColor(color) ? brandColor2ColorParams(color) : {};

    if (color?.brandColorId && color.brandColorId in byId) {
        // @ts-ignore
        const { hexCode, id, name, alpha: opacity } = byId[color.brandColorId];

        return { hexCode, ...extraParams, id, name, opacity };
    }

    const hexCode = rgbToHex(colorToCSS(color)).replace('#', '');

    return {
        hexCode,
        // @ts-ignore
        opacity: color.opacity,
        ...extraParams,
        id: undefined,
        name: undefined,
    };
};

const retrieveBrandColor = (
    styles: Set<string | null>,
    colors: ExtendedColorParams[],
    byId: { [brandColorId: number]: BrandColor },
    brandColorId?: number,
) => {
    const brandColor = brandColorId && byId[brandColorId];

    if (!brandColor) {
        return;
    }

    if (isGradientColor(brandColor)) {
        const convertedColor = brandColor2ColorParams(brandColor) as Gradient;
        const { name, id } = brandColor;

        const color = {
            brandColorId: id,
            ...convertedColor,
            name,
        } as ExtendedColorParams;

        const key = convertedColor.stops.reduce((acc, curr) => acc + toRGBA(curr), color.brandColorId.toString());

        if (!styles.has(key)) {
            styles.add(key);
            colors.push(color);
        }
    } else {
        // @ts-ignore
        const color = {
            brandColorId: brandColor.id,
            // @ts-ignore
            ...rgbaToObject(hexToRgb(brandColor.hexCode, brandColor.alpha)),
            name: brandColor.name,
        } as ExtendedColorParams;
        const key = toRGBA(color as SolidColor) + color.brandColorId;

        if (!styles.has(key)) {
            styles.add(key);
            colors.push(color);
        }
    }
};

export const collectConfigureColors = (
    templateElement: TemplateElement,
    brandColorsPropName: string,
    colorPropName: string,
    byId: { [brandColorId: number]: BrandColor },
): ExtendedColorParams[] => {
    const get = (obj: any, path: string) => path.split('.').reduce((accum, p) => accum && accum[p], obj);
    const styles = new Set<string | null>();
    const colors: ExtendedColorParams[] = [];

    (get(templateElement.properties, brandColorsPropName) || []).forEach((brandColorId: number) => {
        retrieveBrandColor(styles, colors, byId, brandColorId);
    });

    // Retrieving default persisten color from template
    const color = colorPropName.split('.').reduce((accum, current) => accum[current], templateElement.properties);

    // todo: Something is wrong here!
    if (!color.brandColorId) {
        colors.push({ ...color, name: rgbToHex(colorToCSS(color)) } as ExtendedColorParams);
    } else {
        retrieveBrandColor(styles, colors, byId, color.brandColorId);
    }

    return colors;
};
